import { render, staticRenderFns } from "./BaseQuestionMarkTooltip.vue?vue&type=template&id=a8e831dc&"
import script from "./BaseQuestionMarkTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseQuestionMarkTooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseQuestionMarkTooltip.vue?vue&type=style&index=0&id=a8e831dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports